import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCalendarCheck, faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../components/ui/button';
import heroVideo from '../assets/video/hero.mp4';

const bookingUrl = 'https://outlook.office365.com/book/RequestDemo@vgroupinc.com/';

const demoVideos = [
{
    title: 'C2C Setup Guide: Create Your Business Account Easily',
    description: 'Easy to use and enable it for your organization',
    type: 'youtube',
    src: 'https://www.youtube.com/embed/c5ixv7u2gdA',
  },
  {
    title: 'Experience Context to Call: See Both Sides of the Conversation',
    description: 'See the customer journey and handoff experience in action.',
    type: 'youtube',
    src: 'https://www.youtube.com/embed/H4qF5kK-WCw?rel=0',
  },
  {
    title: 'Turn Shopify Visitors Into Buyers with Context to Call',
    description: 'A focused walkthrough of the flow.',
    type: 'youtube',
    src: 'https://www.youtube.com/embed/aOI2hACfbZM',
  },
];

const DemoPage = () => {
  return (
    <main className="demo-page">
      <section className="demo-hero">
        <div className="section-container demo-hero-grid">
          <div className="demo-hero-copy">
            <div className="section-label">Product Demos</div>
            <h1>Context to Call demos</h1>
            <p>
              Browse quick product videos or schedule a guided walkthrough with our team at your convenience.
            </p>
          </div>
          <div className="demo-booking-panel">
            <FontAwesomeIcon icon={faCalendarCheck} />
            <h2>Need a guided demo?</h2>
            <p>Schedule a live walkthrough tailored to your business.</p>
            <Button asChild className="nav-demo-btn">
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer">
                Book a Demo <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </Button>
          </div>
        </div>
      </section>

      <section className="demo-videos-section">
        <div className="section-container">
          <div className="demo-video-grid">
            {demoVideos.map((video) => (
              <article className="demo-video-card" key={video.title}>
                <div className="demo-video-frame">
                  {video.type === 'local' ? (
                    <video src={video.src} controls preload="metadata" playsInline />
                  ) : (
                    <iframe
                      src={video.src}
                      title={video.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  )}
                </div>
                <div className="demo-video-copy">
                  <FontAwesomeIcon icon={faCirclePlay} />
                  <div>
                    <h2>{video.title}</h2>
                    <p>{video.description}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default DemoPage;
